import React from 'react';
import Offer from './offer/offer';

interface Props {
  currentProduct: string | null;
  discount?: boolean;
  secondScreenWrapper?: boolean;
  tariff?: string;
}

export const PaymentOffer = React.memo<Props>(
  function PaymentOffer({ currentProduct, secondScreenWrapper }) {
    return <Offer currentProduct={currentProduct} secondScreenWrapper={secondScreenWrapper} />;
  },
  (prevProps, nextProps) => {
    return (
      prevProps.discount === nextProps.discount &&
      prevProps.currentProduct === nextProps.currentProduct &&
      prevProps.tariff === nextProps.tariff &&
      prevProps.secondScreenWrapper === nextProps.secondScreenWrapper
    );
  }
);
